import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { Directive, forwardRef, Input } from '@angular/core';
import { CustomVirtualScrollStrategy } from '@app/utils/custom-virtual-scroll-strategy';

@Directive({
  selector: '[customVirtualScroll]',
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useFactory: (d: CustomVirtualScrollDirective) => d._scrollStrategy,
      deps: [forwardRef(() => CustomVirtualScrollDirective)],
    },
  ],
})
export class CustomVirtualScrollDirective {
  @Input()
  set heights(value: number[] | null) {
    if (value && this._heights.length !== value.length) {
      this._scrollStrategy.updateHeights(value);
      this._heights = value;
    }
  }

  @Input()
  set paddingTop(value: number | null) {
    this._scrollStrategy.updateTopOffset(value ?? 0);
  }

  @Input()
  set paddingBottom(value: number | null) {
    this._scrollStrategy.updateBottomOffset(value ?? 0);
  }

  _scrollStrategy = new CustomVirtualScrollStrategy();
  private _heights: number[] = [];
}
